(() => {
    const DEBOUNCE_MS = 260;
    const state = {
        timers: new Map,
        controllers: new Map,
        updating: 0,
        lastScrollY: 0,
        focusHint: null,
        cartFetchPromise: null,
        cartFetchTs: 0,
        cartFetchValue: null,
        refreshPromise: null,
        refreshTimer: 0,
        headerBadgeSyncTimer: 0
    };
    function clearTimer(key) {
        const timer = state.timers.get(key);
        if (timer) {
            try {
                window.clearTimeout(timer);
            } catch (e) {}
            state.timers.delete(key);
        }
    }
    function cleanupController(key, controller) {
        const current = state.controllers.get(key);
        if (!current || current === controller) {
            state.controllers.delete(key);
        }
    }
    function cleanupTransientState() {
        try {
            state.timers.forEach(timer => {
                try {
                    window.clearTimeout(timer);
                } catch (e) {}
            });
            state.timers.clear();
        } catch (e) {}
        try {
            state.controllers.forEach(controller => {
                try {
                    controller.abort();
                } catch (e) {}
            });
            state.controllers.clear();
        } catch (e) {}
        if (state.refreshTimer) {
            try {
                window.clearTimeout(state.refreshTimer);
            } catch (e) {}
            state.refreshTimer = 0;
        }
        if (state.headerBadgeSyncTimer) {
            try {
                window.clearTimeout(state.headerBadgeSyncTimer);
            } catch (e) {}
            state.headerBadgeSyncTimer = 0;
        }
        state.focusHint = null;
        state.refreshPromise = null;
        state.cartFetchPromise = null;
        state.cartFetchTs = 0;
        state.cartFetchValue = null;
        const ctx = getCartContext();
        if (ctx) releaseLoadingUI(ctx);
    }
    function setControlsDisabled(ctx, disabled) {
        if (!ctx || !ctx.root) return;
        try {
            ctx.root.classList.toggle("es-cart-is-busy", !!disabled);
            ctx.root.setAttribute("aria-busy", disabled ? "true" : "false");
        } catch (e) {}
        const controls = ctx.root.querySelectorAll(".es-qty-btn, .cart-qty-input, .js-qty__adjust, .js-qty__num, [data-es-cart-edit-rx], .checkout-button");
        controls.forEach(el => {
            try {
                if (disabled && !el.hasAttribute("data-es-prev-tabindex")) {
                    const prevTabIndex = el.getAttribute("tabindex");
                    el.setAttribute("data-es-prev-tabindex", prevTabIndex == null ? "" : prevTabIndex);
                }
                if ("disabled" in el) el.disabled = !!disabled;
                el.setAttribute("aria-disabled", disabled ? "true" : "false");
                if (disabled) {
                    el.setAttribute("tabindex", "-1");
                } else if (el.hasAttribute("data-es-prev-tabindex")) {
                    const storedTabIndex = el.getAttribute("data-es-prev-tabindex");
                    if (storedTabIndex === "") el.removeAttribute("tabindex"); else el.setAttribute("tabindex", storedTabIndex);
                    el.removeAttribute("data-es-prev-tabindex");
                }
            } catch (e) {}
        });
        const removeLinks = ctx.root.querySelectorAll("a.remove");
        removeLinks.forEach(link => {
            try {
                if (disabled && !link.hasAttribute("data-es-prev-tabindex")) {
                    const prevTabIndex = link.getAttribute("tabindex");
                    link.setAttribute("data-es-prev-tabindex", prevTabIndex == null ? "" : prevTabIndex);
                }
                link.setAttribute("aria-disabled", disabled ? "true" : "false");
                if (disabled) {
                    link.setAttribute("tabindex", "-1");
                } else if (link.hasAttribute("data-es-prev-tabindex")) {
                    const storedTabIndex = link.getAttribute("data-es-prev-tabindex");
                    if (storedTabIndex === "") link.removeAttribute("tabindex"); else link.setAttribute("tabindex", storedTabIndex);
                    link.removeAttribute("data-es-prev-tabindex");
                } else {
                    link.removeAttribute("tabindex");
                }
            } catch (e) {}
        });
    }
    function setStatus(ctx, message) {
        if (!ctx || !ctx.root) return;
        const live = ctx.root.querySelector("[data-es-cart-live-status]");
        if (!live) return;
        const text = String(message || "").trim();
        window.clearTimeout(live.__esLiveTimer);
        live.textContent = "";
        if (!text) return;
        live.__esLiveTimer = window.setTimeout(() => {
            live.textContent = text;
        }, 24);
    }
    function rememberFocus(el) {
        if (!el || !el.closest) {
            state.focusHint = null;
            return;
        }
        const row = el.closest("tr.cart_item");
        if (!row) {
            state.focusHint = null;
            return;
        }
        let target = null;
        if (el.closest(".es-qty-btn--minus")) target = "minus"; else if (el.closest(".es-qty-btn--plus")) target = "plus"; else if (el.closest(".cart-qty-input, .js-qty__num")) target = "input"; else if (el.closest("a.remove")) target = "remove"; else if (el.closest("[data-es-cart-edit-rx]")) target = "edit";
        state.focusHint = {
            key: row.getAttribute("data-line-key") || "",
            target: target
        };
    }
    function restoreFocus(ctx) {
        if (!ctx || !ctx.root || !state.focusHint || !state.focusHint.key) return;
        const row = ctx.root.querySelector(`tr.cart_item[data-line-key="${cssEscape(state.focusHint.key)}"]`);
        if (!row) {
            state.focusHint = null;
            return;
        }
        row.setAttribute("data-es-focus-lock", "1");
        let selector = ".cart-qty-input, .js-qty__num";
        switch (state.focusHint.target) {
          case "minus":
            selector = ".es-qty-btn--minus";
            break;

          case "plus":
            selector = ".es-qty-btn--plus";
            break;

          case "remove":
            selector = "a.remove";
            break;

          case "edit":
            selector = "[data-es-cart-edit-rx]";
            break;

          default:
            selector = ".cart-qty-input, .js-qty__num";
        }
        const target = row.querySelector(selector) || row.querySelector(".cart-qty-input, .js-qty__num, .es-qty-btn, a.remove");
        if (target && typeof target.focus === "function") {
            try {
                target.focus({
                    preventScroll: true
                });
            } catch (e) {
                try {
                    target.focus();
                } catch (_e) {}
            }
        }
        window.setTimeout(() => {
            try {
                row.removeAttribute("data-es-focus-lock");
            } catch (e) {}
        }, 900);
        state.focusHint = null;
    }
    function updateHeaderCartCount(count) {
        const value = Math.max(0, parseInt(count, 10) || 0);
        const hasItems = value > 0;
        try {
            document.documentElement.classList.toggle("es-cart-has-items", hasItems);
            document.documentElement.setAttribute("data-es-cart-count", String(value));
            if (document.body) document.body.classList.toggle("es-cart-has-items", hasItems);
            if (window.localStorage) {
                localStorage.setItem("es_cart_has_items", hasItems ? "1" : "0");
                localStorage.setItem("es_cart_count", String(value));
            }
        } catch (e) {}
        document.querySelectorAll(".enj-cartcount").forEach(badge => {
            const badgeText = value > 99 ? "99+" : value > 9 ? "9+" : String(value);
            badge.textContent = badgeText;
            badge.classList.remove("es-badge-hidden");
            badge.classList.toggle("is-zero-count", value === 0);
            badge.setAttribute("aria-label", `${value} item${value === 1 ? "" : "s"} in cart`);
        });
        document.querySelectorAll(".js-cart-link, #header a.cart[href*='/cart'], .menu_moblie .menuright a[href*='/cart']").forEach(anchor => {
            anchor.classList.add("js-cart-link", "cart", "es-header-badge-anchor");
            anchor.classList.toggle("es-has-items", hasItems);
            anchor.setAttribute("data-cart-count", String(value));
            anchor.setAttribute("data-es-cart-has-items", hasItems ? "1" : "0");
            anchor.setAttribute("aria-label", hasItems ? `Cart, ${value} item${value === 1 ? "" : "s"}` : "Cart");
            const dot = anchor.querySelector(".es-cart-dot");
            if (dot) {
                dot.classList.toggle("is-visible", hasItems);
                dot.style.setProperty("display", "block", "important");
                dot.style.setProperty("visibility", hasItems ? "visible" : "hidden", "important");
                dot.style.setProperty("opacity", hasItems ? "1" : "0", "important");
                dot.style.setProperty("transform", hasItems ? "scale(1)" : "scale(.85)", "important");
            }
        });
        try {
            if (window.EyeshellsHeaderCartBadge && typeof window.EyeshellsHeaderCartBadge.setCount === "function") {
                window.EyeshellsHeaderCartBadge.setCount(value, { source: "es-cart-live-update" });
            }
        } catch (e) {}
    }
    function needsHeaderBadgeHydration() {
        try {
            if (window.localStorage && localStorage.getItem("es_cart_has_items") === "1") {
                return !document.querySelector(".js-cart-link .es-cart-dot.is-visible, #header a.cart .es-cart-dot.is-visible");
            }
        } catch (e) {}
        return false;
    }
    function willCartBeEmptyAfterRemove(ctx, row, bundleId) {
        try {
            if (!ctx || !ctx.root || !row) return false;
            const rows = Array.from(ctx.root.querySelectorAll("tr.cart_item[data-line-key]"));
            if (!rows.length) return false;
            const targetBundle = String(bundleId || row.getAttribute("data-bundle-id") || "");
            const remainingRows = rows.filter(candidate => {
                if (!candidate || candidate === row) return false;
                if (targetBundle) return String(candidate.getAttribute("data-bundle-id") || "") !== targetBundle;
                return true;
            });
            return remainingRows.length === 0;
        } catch (e) {
            return false;
        }
    }
    function clearHeaderCartImmediately() {
        updateHeaderCartCount(0);
        try { document.dispatchEvent(new CustomEvent("es:cart-empty", { detail: { source: "es-cart-page" } })); } catch (e) {}
    }
    function queueHeaderBadgeSyncFromServer(delay = 80, forceFresh = true) {
        try {
            if (state.headerBadgeSyncTimer) window.clearTimeout(state.headerBadgeSyncTimer);
        } catch (e) {}
        state.headerBadgeSyncTimer = window.setTimeout(async () => {
            state.headerBadgeSyncTimer = 0;
            try {
                if (forceFresh) invalidateCartSnapshot();
                const cart = await fetchLatestCart(undefined, !!forceFresh);
                updateHeaderCartCount(cart && cart.item_count || 0);
            } catch (e) {}
        }, Math.max(0, parseInt(delay, 10) || 0));
    }
    async function hydrateHeaderBadgeFromServer() {
        if (window.__ES_HEADER_BADGE_SYNC_PENDING) return;
        if (!needsHeaderBadgeHydration()) return;
        window.__ES_HEADER_BADGE_SYNC_PENDING = true;
        try {
            const cart = await fetchLatestCart();
            const count = getDisplayItemCount(cart);
            updateHeaderCartCount(count);
            document.documentElement.classList.toggle("es-cart-has-items", count > 0);
            try {
                if (window.localStorage) localStorage.setItem("es_cart_has_items", count > 0 ? "1" : "0");
            } catch (e) {}
        } catch (e) {} finally {
            window.__ES_HEADER_BADGE_SYNC_PENDING = false;
        }
    }
    function clearGlobalDrawerLoading() {
        try {
            document.body.classList.remove("drawer--is-loading");
        } catch (e) {}
        try {
            document.documentElement.classList.remove("drawer--is-loading");
        } catch (e) {}
    }
    function scheduleDrawerLoadingCleanup() {
        clearGlobalDrawerLoading();
        try {
            window.requestAnimationFrame(clearGlobalDrawerLoading);
        } catch (e) {}
        try {
            window.setTimeout(clearGlobalDrawerLoading, 60);
            window.setTimeout(clearGlobalDrawerLoading, 220);
        } catch (e) {}
    }
    function releaseLoadingUI(ctx) {
        scheduleDrawerLoadingCleanup();
        try {
            if (ctx && ctx.sectionEl) {
                ctx.sectionEl.classList.remove("es-cart-replacing");
                ctx.sectionEl.style.minHeight = "";
            }
        } catch (e) {}
        try {
            setControlsDisabled(ctx, false);
        } catch (e) {}
    }
    function cssEscape(val) {
        const s = String(val || "");
        if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(s);
        return s.replace(/["\\]/g, "\\$&");
    }
    function moneyFormat() {
        return window.money_format || "${{amount}}";
    }
    function cartUrl(path) {
        const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
        return root.replace(/\/$/, "/") + String(path || "").replace(/^\//, "");
    }
    function suppressLeakedDrawerLoading() {
        const root = document.querySelector(".page-cart");
        if (!root) return;
        scheduleDrawerLoadingCleanup();
        if (!window.MutationObserver) return;
        if (document.documentElement.__esCartDrawerObserverAttached) return;
        document.documentElement.__esCartDrawerObserverAttached = true;
        const observer = new MutationObserver(() => {
            if (document.documentElement.classList.contains("drawer--is-loading") || document.body && document.body.classList.contains("drawer--is-loading")) {
                scheduleDrawerLoadingCleanup();
            }
        });
        try {
            observer.observe(document.documentElement, {
                attributes: true,
                attributeFilter: [ "class" ]
            });
        } catch (e) {}
        try {
            if (document.body) observer.observe(document.body, {
                attributes: true,
                attributeFilter: [ "class" ]
            });
        } catch (e) {}
    }
    function formatMoney(cents) {
        const n = typeof cents === "number" ? cents : parseInt(cents, 10);
        if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
            try {
                return window.Shopify.formatMoney(n, moneyFormat());
            } catch (e) {}
            try {
                return window.Shopify.formatMoney(n);
            } catch (e) {}
        }
        const v = (Number.isFinite(n) ? n : 0) / 100;
        return v.toFixed(2);
    }
    function getCartContext() {
        const root = document.querySelector(".page-cart");
        if (!root) return null;
        const sectionEl = document.querySelector("#shopify-section-main") || root.closest('[id^="shopify-section-"]');
        if (!sectionEl) return null;
        const form = root.querySelector('form[action$="/cart"]');
        return {
            root: root,
            form: form,
            sectionEl: sectionEl
        };
    }
    function beginUpdate(ctx) {
        state.updating += 1;
        if (state.updating === 1) {
            state.lastScrollY = window.scrollY || window.pageYOffset || 0;
            releaseLoadingUI(ctx);
            ctx.sectionEl.classList.add("es-cart-replacing");
            try {
                const h = ctx.sectionEl.getBoundingClientRect().height;
                if (h) ctx.sectionEl.style.minHeight = `${h}px`;
            } catch (e) {}
            setControlsDisabled(ctx, true);
        }
    }
    function endUpdate(ctx) {
        state.updating = Math.max(0, state.updating - 1);
        if (state.updating === 0) {
            releaseLoadingUI(ctx);
            try {
                window.scrollTo({
                    top: state.lastScrollY,
                    left: 0,
                    behavior: "auto"
                });
            } catch (e) {
                window.scrollTo(0, state.lastScrollY);
            }
        }
    }
    function parseQty(val) {
        const n = parseInt(val, 10);
        if (!Number.isFinite(n)) return 0;
        return Math.max(0, n);
    }
    function getMaxQty(input) {
        if (!input) return null;
        const raw = parseInt(input.getAttribute("data-max-qty") || "", 10);
        return Number.isFinite(raw) && raw >= 0 ? raw : null;
    }
    function clampQtyToLimit(input, qty) {
        const next = Math.max(0, parseInt(qty, 10) || 0);
        const max = getMaxQty(input);
        return max === null ? next : Math.min(next, max);
    }
    function getQtyLimitMessage(input) {
        const max = getMaxQty(input);
        if (max === null) return "";
        const row = input && input.closest ? input.closest("tr.cart_item") : null;
        const label = row ? row.getAttribute("data-item-label") || "This item" : "This item";
        return max <= 0 ? `${label} is currently out of stock.` : `Only ${max} available for ${label}.`;
    }
    function getQtyLimitShortMessage(input) {
        const max = getMaxQty(input);
        if (max === null) return "";
        return max <= 0 ? "Currently out of stock" : `Only ${max} available`;
    }
    function getQtyLimitNoteEl(input) {
        if (!input || !input.closest) return null;
        const rowQty = input.closest(".es-cart-row-qty");
        if (!rowQty) return null;
        return rowQty.querySelector("[data-es-qty-limit-note]");
    }
    function setQtyLimitNote(input, forceVisible = false) {
        const note = getQtyLimitNoteEl(input);
        if (!note) return;
        const max = getMaxQty(input);
        const qty = parseQty(input && input.value);
        const shouldShow = !!forceVisible || max !== null && qty >= max;
        if (!shouldShow || !max && max !== 0) {
            note.hidden = true;
            note.textContent = "";
            note.classList.remove("is-visible", "is-bump");
            if (note.__esBumpTimer) window.clearTimeout(note.__esBumpTimer);
            return;
        }
        note.textContent = getQtyLimitShortMessage(input);
        note.hidden = false;
        note.classList.add("is-visible");
        if (forceVisible) {
            note.classList.remove("is-bump");
            void note.offsetWidth;
            note.classList.add("is-bump");
            if (note.__esBumpTimer) window.clearTimeout(note.__esBumpTimer);
            note.__esBumpTimer = window.setTimeout(() => note.classList.remove("is-bump"), 520);
        }
    }
    function maybeClampInputToLimit(input, attemptedQty, announce = false) {
        if (!input) return Math.max(0, parseInt(attemptedQty, 10) || 0);
        const next = Math.max(0, parseInt(attemptedQty, 10) || 0);
        const clamped = clampQtyToLimit(input, next);
        if (String(clamped) !== String(input.value || "")) input.value = String(clamped);
        if (announce && clamped < next) {
            const ctx = getCartContext();
            if (ctx) setStatus(ctx, getQtyLimitMessage(input));
            setQtyLimitNote(input, true);
        } else {
            setQtyLimitNote(input, false);
        }
        return clamped;
    }
    function getCommittedQty(input) {
        if (!input) return null;
        const committed = parseInt(input.getAttribute("data-es-current-qty") || "", 10);
        return Number.isFinite(committed) ? Math.max(0, committed) : null;
    }
    function setCommittedQty(input, qty) {
        if (!input) return;
        const next = Math.max(0, parseInt(qty, 10) || 0);
        input.setAttribute("data-es-current-qty", String(next));
    }
    function setPendingQty(input, qty) {
        if (!input) return;
        const next = Math.max(0, parseInt(qty, 10) || 0);
        input.setAttribute("data-es-pending-qty", String(next));
    }
    function getPendingQty(input) {
        if (!input) return null;
        const pending = parseInt(input.getAttribute("data-es-pending-qty") || "", 10);
        return Number.isFinite(pending) ? Math.max(0, pending) : null;
    }
    function clearPendingQty(input) {
        if (!input) return;
        input.removeAttribute("data-es-pending-qty");
    }
    const MINUS_GLYPH = "&minus;";
    const TRASH_GLYPH = '<svg class="es-qty-btn__trash" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 2.25h4M2.75 4h10.5M6.75 6.25v5M9.25 6.25v5M4.25 4l.4 7.05c.03.56.49.99 1.05.99h4.6c.56 0 1.02-.43 1.05-.99L11.75 4M6.55 2.25l.14-.43c.1-.31.39-.52.72-.52h1.18c.33 0 .62.21.72.52l.14.43" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    function updateQtyButtonState(input) {
        if (!input || !input.closest) return;
        const wrap = input.closest(".es-qty-control");
        if (!wrap) return;
        const minusBtn = wrap.querySelector(".es-qty-btn--minus");
        const plusBtn = wrap.querySelector(".es-qty-btn--plus");
        if (!minusBtn) return;
        const glyph = minusBtn.querySelector(".es-qty-btn__glyph");
        const qty = parseQty(input.value);
        const max = getMaxQty(input);
        const removeReady = qty <= 1;
        const label = removeReady ? "Remove item" : "Decrease quantity";
        minusBtn.setAttribute("data-mode", removeReady ? "remove" : "decrease");
        minusBtn.setAttribute("aria-label", label);
        minusBtn.setAttribute("title", label);
        wrap.classList.toggle("is-remove-ready", removeReady);
        if (glyph) {
            const nextMarkup = removeReady ? TRASH_GLYPH : MINUS_GLYPH;
            if (glyph.innerHTML !== nextMarkup) glyph.innerHTML = nextMarkup;
        }
        if (plusBtn) {
            const atMax = max !== null && qty >= max;
            plusBtn.disabled = false;
            plusBtn.setAttribute("aria-disabled", atMax ? "true" : "false");
            plusBtn.classList.toggle("is-maxed", !!atMax);
            const plusLabel = atMax ? getQtyLimitShortMessage(input) : "Increase quantity";
            plusBtn.setAttribute("aria-label", plusLabel);
            plusBtn.setAttribute("title", plusLabel);
        }
        setQtyLimitNote(input, false);
    }
    function refreshQtyButtonStates(root) {
        const scope = root && root.querySelectorAll ? root : document;
        const inputs = scope.querySelectorAll(".page-cart .cart-qty-input, .page-cart .js-qty__num");
        inputs.forEach(input => {
            if (getCommittedQty(input) === null) setCommittedQty(input, input.value);
            updateQtyButtonState(input);
        });
    }
    async function postChange(line, quantity, signal) {
        const body = new URLSearchParams({
            line: String(line),
            quantity: String(quantity)
        });
        const res = await fetch(cartUrl("cart/change.js"), {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                Accept: "application/json"
            },
            body: body,
            signal: signal
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
    }
    async function postChangeByKey(key, quantity, signal) {
        const body = new URLSearchParams({
            id: String(key),
            quantity: String(quantity)
        });
        const res = await fetch(cartUrl("cart/change.js"), {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                Accept: "application/json"
            },
            body: body,
            signal: signal
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
    }
    async function postBundleUpdate(keys, quantity, signal) {
        const body = new URLSearchParams;
        body.append("quantity", String(quantity));
        (keys || []).forEach(key => {
            if (!key) return;
            body.append(`updates[${key}]`, String(quantity));
        });
        const res = await fetch(cartUrl("cart/update.js"), {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                Accept: "application/json"
            },
            body: body,
            signal: signal
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
    }
    async function fetchLatestCart(signal, forceFresh = false) {
        const now = Date.now();
        if (!forceFresh && state.cartFetchValue && state.cartFetchTs && now - state.cartFetchTs < 180) {
            return state.cartFetchValue;
        }
        if (!forceFresh && state.cartFetchPromise) {
            return state.cartFetchPromise;
        }
        state.cartFetchPromise = fetch(cartUrl(`cart.js?ts=${Date.now()}`), {
            method: "GET",
            credentials: "same-origin",
            headers: {
                Accept: "application/json"
            },
            cache: "no-store",
            signal: signal
        }).then(res => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.json();
        }).then(cart => {
            state.cartFetchValue = cart;
            state.cartFetchTs = Date.now();
            return cart;
        }).finally(() => {
            state.cartFetchPromise = null;
        });
        return state.cartFetchPromise;
    }
    function invalidateCartSnapshot() {
        state.cartFetchTs = 0;
        state.cartFetchValue = null;
    }
    function parseBundleMeta(props) {
        props = props || {};
        const raw = String(props._eslb || "").trim();
        const parts = raw ? raw.split("|") : [];
        return {
            id: String(parts[0] || "").trim(),
            role: String(parts[1] || "").trim().toLowerCase(),
            order: String(parts[2] || "").trim()
        };
    }
    function getBundleIdFromProperties(props) {
        return parseBundleMeta(props).id;
    }
    function normalizeBundleExplicitRole(value) {
        const role = String(value || "").trim().toLowerCase();
        return role === "frame" || role === "lens" || role === "prism" ? role : "";
    }
    function resolveBundleExplicitRole(props) {
        return normalizeBundleExplicitRole(parseBundleMeta(props).role);
    }
    function resolveBundleOrderRole(props) {
        return normalizeBundleOrderRole(parseBundleMeta(props).order);
    }
    function normalizeBundleOrderRole(value) {
        const order = String(value || "").trim();
        if (order === "1") return "frame";
        if (order === "2") return "lens";
        if (order === "3") return "prism";
        return "";
    }
    function bundleRoleWeight(role) {
        if (role === "frame") return 1;
        if (role === "lens") return 2;
        if (role === "prism") return 3;
        return 9;
    }
    function sortBundleItems(groupItems) {
        return (groupItems || []).slice().sort((a, b) => {
            const roleA = resolveBundleExplicitRole(a && a.properties) || resolveBundleOrderRole(a && a.properties) || inferBundleRole(a, groupItems) || "";
            const roleB = resolveBundleExplicitRole(b && b.properties) || resolveBundleOrderRole(b && b.properties) || inferBundleRole(b, groupItems) || "";
            const weightDiff = bundleRoleWeight(roleA) - bundleRoleWeight(roleB);
            if (weightDiff) return weightDiff;
            const lineA = parseInt(a && (a.__esLine || a.line), 10) || 0;
            const lineB = parseInt(b && (b.__esLine || b.line), 10) || 0;
            if (lineA && lineB && lineA !== lineB) return lineA - lineB;
            return 0;
        });
    }
    function inferBundleRole(item, groupItems) {
        if (!item) return "";
        const props = item.properties || {};
        const explicit = resolveBundleExplicitRole(props);
        if (explicit) return explicit;
        const orderRole = resolveBundleOrderRole(props);
        if (orderRole) return orderRole;
        const title = [ item.product_title, item.title, item.product_type ].filter(Boolean).join(" ").toLowerCase();
        if (props["Frame"]) return "lens";
        if (props["Applied To"]) return "prism";
        if (/prism/.test(title)) return "prism";
        if (/(high[- ]?index|mid[- ]?index|photochromic|transitions|blue blocker|blue light|polycarbonate|impact[- ]?resistant|polarized|progressive|bifocal|reading strength|age assist|tint|sunglasses|xtractive|drivewear|clear lens|standard clear)/.test(title)) return "lens";
        if (props["Lens"] || props["Prescription Type"] || props["Prescription Status"]) return "frame";
        if (props["Prism OD"] || props["Prism OS"]) return "prism";
        if (props["Lens Group"] || props["OD Right"] || props["OS Left"] || props["PD"] || props["ADD"] || props["Reading Strength"]) return "lens";
        if (props["Prescription Status"] || props["Lens"]) return "frame";
        if (getBundleIdFromProperties(props)) return "frame";
        return "";
    }
    function getBundleDisplayQty(groupItems) {
        if (!Array.isArray(groupItems) || !groupItems.length) return 0;
        let frameQty = 0;
        let lensQty = 0;
        let prismQty = 0;
        let fallbackQty = 0;
        let minPositiveQty = 0;
        groupItems.forEach(item => {
            const qty = Math.max(0, parseInt(item && item.quantity, 10) || 0);
            if (!fallbackQty && qty > 0) fallbackQty = qty;
            if (qty > 0 && (!minPositiveQty || qty < minPositiveQty)) minPositiveQty = qty;
            const role = inferBundleRole(item, groupItems);
            if (role === "frame" && !frameQty && qty > 0) frameQty = qty; else if (role === "lens" && !lensQty && qty > 0) lensQty = qty; else if (role === "prism" && !prismQty && qty > 0) prismQty = qty;
        });
        return frameQty || lensQty || prismQty || minPositiveQty || fallbackQty || 0;
    }
    function getDisplayItemCount(cart) {
        if (!cart || !Array.isArray(cart.items)) return 0;
        const bundleMap = new Map;
        let count = 0;
        cart.items.forEach(item => {
            const bundleId = item && item.properties ? getBundleIdFromProperties(item.properties) : "";
            if (!bundleId) {
                count += Math.max(0, parseInt(item && item.quantity, 10) || 0);
                return;
            }
            if (!bundleMap.has(bundleId)) bundleMap.set(bundleId, []);
            bundleMap.get(bundleId).push(item);
        });
        bundleMap.forEach(groupItems => {
            count += getBundleDisplayQty(groupItems);
        });
        return count;
    }
    function reorderCartRows(ctx, cart) {
        if (!ctx || !ctx.root || !cart || !Array.isArray(cart.items) || !cart.items.length) return;
        const tbody = ctx.root.querySelector("table.shop_table tbody");
        if (!tbody) return;
        const rowByKey = new Map;
        Array.from(tbody.querySelectorAll("tr.cart_item[data-line-key]")).forEach(row => {
            const key = row.getAttribute("data-line-key");
            if (key) rowByKey.set(key, row);
        });
        const bundleRows = new Map;
        rowByKey.forEach(row => {
            const bundleId = row.getAttribute("data-bundle-id") || "";
            if (!bundleId) return;
            if (!bundleRows.has(bundleId)) bundleRows.set(bundleId, {});
            const entry = bundleRows.get(bundleId);
            const productType = String(row.getAttribute("data-product-type") || "").trim().toLowerCase();
            if (row.getAttribute("data-bundle-master") === "1" || productType === "frame") entry.frame = row; else if (productType === "lens") entry.lens = row; else if (productType === "prism") entry.prism = row; else if (!entry.fallback) entry.fallback = row;
        });
        const desiredRows = [];
        const renderedBundles = new Set;
        cart.items.forEach(item => {
            const bundleId = item && item.properties ? getBundleIdFromProperties(item.properties) : "";
            if (!bundleId) {
                const row = rowByKey.get(item.key);
                if (row) desiredRows.push(row);
                return;
            }
            if (renderedBundles.has(bundleId)) return;
            renderedBundles.add(bundleId);
            const entry = bundleRows.get(bundleId) || {};
            const groupItems = sortBundleItems((cart.items || []).filter(candidate => candidate && candidate.properties && getBundleIdFromProperties(candidate.properties) === bundleId));
            const roleToRow = {
                frame: entry.frame || entry.fallback || null,
                lens: entry.lens || null,
                prism: entry.prism || null
            };
            const pushed = new Set;
            groupItems.forEach(groupItem => {
                const role = inferBundleRole(groupItem, groupItems) || "";
                const row = roleToRow[role] || null;
                if (row && !pushed.has(row)) {
                    desiredRows.push(row);
                    pushed.add(row);
                }
            });
            [ entry.frame, entry.lens, entry.prism, entry.fallback ].forEach(row => {
                if (row && !pushed.has(row)) {
                    desiredRows.push(row);
                    pushed.add(row);
                }
            });
        });
        const currentRows = Array.from(tbody.querySelectorAll("tr.cart_item[data-line-key]"));
        let orderChanged = currentRows.length !== desiredRows.length;
        if (!orderChanged) {
            for (let i = 0; i < desiredRows.length; i += 1) {
                if (desiredRows[i] !== currentRows[i]) {
                    orderChanged = true;
                    break;
                }
            }
        }
        if (!orderChanged) return;
        let cursor = tbody.firstElementChild;
        desiredRows.forEach(row => {
            if (!row || row.parentNode !== tbody) return;
            while (cursor && !cursor.matches("tr.cart_item[data-line-key]")) {
                cursor = cursor.nextElementSibling;
            }
            if (row === cursor) {
                cursor = cursor ? cursor.nextElementSibling : null;
                return;
            }
            tbody.insertBefore(row, cursor || null);
        });
    }
    function updateCartMeta(ctx, cart) {
        if (!ctx || !ctx.root || !cart) return;
        const count = getDisplayItemCount(cart);
        const countText = `${count} item${count === 1 ? "" : "s"}`;
        const subtotalText = formatMoney(cart.items_subtotal_price);
        const totalText = formatMoney(cart.total_price);
        ctx.root.querySelectorAll("[data-es-cart-display-count-text]").forEach(el => {
            el.textContent = countText;
        });
        ctx.root.querySelectorAll("[data-es-cart-summary-count], [data-es-cart-summary-count-inline]").forEach(el => {
            el.textContent = String(count);
        });
        ctx.root.querySelectorAll("[data-es-cart-overview-subtotal], [data-es-cart-summary-subtotal]").forEach(el => {
            el.textContent = subtotalText;
        });
        ctx.root.querySelectorAll("[data-es-cart-summary-total]").forEach(el => {
            el.textContent = totalText;
        });
        updateHeaderCartCount(count);
    }
    function needsMarkupRefresh(ctx, cart) {
        if (!ctx || !ctx.root || !cart || !Array.isArray(cart.items)) return true;
        const rowKeys = new Set;
        ctx.root.querySelectorAll("tr.cart_item[data-line-key]").forEach(row => {
            const key = String(row.getAttribute("data-line-key") || "").trim();
            if (key) rowKeys.add(key);
        });
        if (!rowKeys.size && cart.items.length) return true;
        return cart.items.some(item => !rowKeys.has(String(item && item.key || "").trim()));
    }
    async function refreshCartMarkupFromServer(source = "external", statusMessage = "Cart updated.") {
        const ctx = getCartContext();
        if (!ctx || !ctx.sectionEl || typeof DOMParser === "undefined") return false;
        try {
            const currentUrl = new URL(window.location.href, window.location.origin);
            currentUrl.searchParams.set("es_cart_markup_sync", `${Date.now()}`);
            const res = await fetch(String(currentUrl), {
                method: "GET",
                credentials: "same-origin",
                headers: {
                    Accept: "text/html",
                    "X-Requested-With": "XMLHttpRequest"
                },
                cache: "no-store"
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const html = await res.text();
            const parser = new DOMParser;
            const doc = parser.parseFromString(String(html || ""), "text/html");
            let nextSection = null;
            const currentId = ctx.sectionEl.id || "";
            if (currentId) nextSection = doc.getElementById(currentId);
            if (!nextSection) {
                const nextRoot = doc.querySelector(".page-cart");
                nextSection = nextRoot ? nextRoot.closest('[id^="shopify-section-"]') : null;
            }
            if (!nextSection) return false;
            const replacement = document.importNode ? document.importNode(nextSection, true) : nextSection.cloneNode(true);
            const liveSection = document.getElementById(currentId) || ctx.sectionEl;
            if (!liveSection || !liveSection.parentNode) return false;
            liveSection.parentNode.replaceChild(replacement, liveSection);
            const nextCtx = getCartContext();
            if (!nextCtx) return false;
            refreshQtyButtonStates(nextCtx.root);
            suppressLeakedDrawerLoading();
            releaseLoadingUI(nextCtx);
            restoreFocus(nextCtx);
            setStatus(nextCtx, statusMessage || "Cart updated.");
            return true;
        } catch (e) {
            return false;
        }
    }
    function applyCartState(ctx, cart) {
        if (!ctx || !cart) return false;
        const subtotalText = formatMoney(cart.items_subtotal_price);
        const totalText = formatMoney(cart.total_price);
        ctx.root.querySelectorAll(".cart-subtotal-row .amount, .cart-subtotal .amount, [data-es-cart-summary-subtotal]").forEach(el => {
            el.textContent = subtotalText;
        });
        ctx.root.querySelectorAll(".cart-total-row .amount, [data-es-cart-summary-total]").forEach(el => {
            el.textContent = totalText;
        });
        updateCartMeta(ctx, cart);
        if (!cart.items || cart.items.length === 0) return false;
        if (needsMarkupRefresh(ctx, cart)) return false;
        const keyToIndex = new Map;
        const bundleMap = new Map;
        cart.items.forEach((item, idx) => {
            keyToIndex.set(item.key, idx);
            const bundleId = item && item.properties ? getBundleIdFromProperties(item.properties) : "";
            if (bundleId) {
                if (!bundleMap.has(bundleId)) bundleMap.set(bundleId, []);
                bundleMap.get(bundleId).push(item);
            }
        });
        const rows = Array.from(ctx.root.querySelectorAll("tr.cart_item[data-line-key]"));
        rows.forEach(row => {
            const key = row.getAttribute("data-line-key");
            if (!key || !keyToIndex.has(key)) {
                animateRemoveRow(row);
            }
        });
        cart.items.forEach((item, idx) => {
            const row = ctx.root.querySelector(`tr.cart_item[data-line-key="${cssEscape(item.key)}"]`);
            if (!row) return;
            const newLine = idx + 1;
            row.setAttribute("data-cart-line", String(newLine));
            const qtyInput = row.querySelector(".js-qty__num, .cart-qty-input");
            if (qtyInput) {
                qtyInput.value = String(item.quantity);
                setCommittedQty(qtyInput, item.quantity);
                clearPendingQty(qtyInput);
                updateQtyButtonState(qtyInput);
            }
            const bundleId = row.getAttribute("data-bundle-id") || "";
            const isBundleMaster = row.getAttribute("data-bundle-master") === "1";
            const bundleItems = bundleId ? bundleMap.get(bundleId) || [] : [];
            const unitPrice = isBundleMaster && bundleItems.length ? bundleItems.reduce((sum, bundleItem) => sum + (parseInt(bundleItem.final_price, 10) || 0), 0) : parseInt(item.final_price, 10) || 0;
            const linePriceValue = isBundleMaster && bundleItems.length ? bundleItems.reduce((sum, bundleItem) => sum + (parseInt(bundleItem.line_price, 10) || 0), 0) : parseInt(item.line_price, 10) || 0;
            const priceEl = row.querySelector("[data-es-bundle-unit-price], .product-price .amount");
            if (priceEl) priceEl.textContent = formatMoney(unitPrice);
            const lineTotal = row.querySelector("[data-es-bundle-line-price], [data-es-row-total], .product-subtotal .amount");
            if (lineTotal) lineTotal.textContent = formatMoney(linePriceValue);
            const removeLink = row.querySelector("a.remove");
            if (removeLink) removeLink.setAttribute("href", cartUrl(`cart/change?line=${newLine}&quantity=0`));
        });
        reorderCartRows(ctx, cart);
        restoreFocus(ctx);
        return true;
    }
    function animateRemoveRow(row) {
        if (!row || row.__esRemoving) return;
        row.__esRemoving = true;
        try {
            const h = row.getBoundingClientRect().height;
            row.style.height = `${h}px`;
            row.style.transition = "height 170ms ease, opacity 150ms ease";
            row.style.overflow = "hidden";
            row.style.transform = "none";
            requestAnimationFrame(() => {
                row.style.opacity = "0";
                row.style.height = "0px";
            });
            window.setTimeout(() => {
                try {
                    row.remove();
                } catch (e) {}
            }, 210);
        } catch (e) {
            try {
                row.remove();
            } catch (e2) {}
        }
    }
    function syncCartEcho(cart) {
        if (!cart) return;
    }
    function emitCartUpdated(cart, source = "es-cart-page") {
        try {
            document.dispatchEvent(new CustomEvent("cart:updated", {
                detail: {
                    cart: cart,
                    source: source
                }
            }));
        } catch (e) {}
    }
    function applyExternalCartUpdate(cart, source = "external", statusMessage) {
        if (cart) {
            state.cartFetchValue = cart;
            state.cartFetchTs = Date.now();
        }
        const ctx = getCartContext();
        if (!ctx || !cart) return false;
        const ok = applyCartState(ctx, cart);
        if (!ok) return false;
        refreshQtyButtonStates(ctx.root);
        releaseLoadingUI(ctx);
        setStatus(ctx, statusMessage || "Cart updated.");
        return true;
    }
    async function refreshCartPageFromServer(source = "external", forceFresh = false) {
        const ctx = getCartContext();
        if (!ctx) return false;
        if (!forceFresh && state.refreshPromise) return state.refreshPromise;
        state.refreshPromise = (async () => {
            try {
                const cart = await fetchLatestCart(undefined, forceFresh);
                const ok = applyExternalCartUpdate(cart, source, "Cart updated.");
                if (ok) return true;
                const markupOk = await refreshCartMarkupFromServer(source, "Cart updated.");
                if (!markupOk) window.location.reload();
                return markupOk;
            } catch (e) {
                const markupOk = await refreshCartMarkupFromServer(source, "Cart updated.").catch(() => false);
                return !!markupOk;
            } finally {
                state.refreshPromise = null;
            }
        })();
        return state.refreshPromise;
    }
    function queueRefreshFromServer(source = "external", forceFresh = false, delay = 48) {
        if (state.refreshTimer) {
            window.clearTimeout(state.refreshTimer);
            state.refreshTimer = 0;
        }
        state.refreshTimer = window.setTimeout(() => {
            state.refreshTimer = 0;
            refreshCartPageFromServer(source, forceFresh);
        }, delay);
    }
    async function changeLine(line, quantity, itemKey) {
        invalidateCartSnapshot();
        const ctx = getCartContext();
        if (!ctx) return;
        const activeEl = document.activeElement;
        rememberFocus(activeEl && ctx.root.contains(activeEl) ? activeEl : null);
        const row = ctx.root.querySelector(`tr.cart_item[data-line-key="${cssEscape(itemKey || "")}"]`) || ctx.root.querySelector(`tr.cart_item[data-cart-line="${line}"]`);
        const itemLabel = row ? row.getAttribute("data-item-label") || "Item" : "Item";
        const key = itemKey || String(line);
        clearTimer(key);
        const prev = state.controllers.get(key);
        if (prev) {
            try {
                prev.abort();
            } catch (e) {}
        }
        const controller = new AbortController;
        state.controllers.set(key, controller);
        beginUpdate(ctx);
        if (Math.max(0, parseInt(quantity, 10) || 0) === 0 && willCartBeEmptyAfterRemove(ctx, row, row ? row.getAttribute("data-bundle-id") || "" : "")) {
            clearHeaderCartImmediately();
        }
        try {
            const cart = itemKey ? await postChangeByKey(itemKey, quantity, controller.signal) : await postChange(line, quantity, controller.signal);
            const ok = applyCartState(ctx, cart);
            if (ok) refreshQtyButtonStates(ctx.root);
            syncCartEcho(cart);
            emitCartUpdated(cart, "es-cart-page");
            const statusMessage = quantity === 0 ? `${itemLabel} removed.` : `${itemLabel} quantity updated to ${Math.max(0, quantity)}.`;
            setStatus(ctx, statusMessage);
            releaseLoadingUI(ctx);
            if (!ok) {
                const markupOk = await refreshCartMarkupFromServer("es-cart-page", statusMessage);
                if (!markupOk) window.location.reload();
            }
        } catch (err) {
            const qtyInput = row ? row.querySelector(".js-qty__num, .cart-qty-input") : null;
            clearPendingQty(qtyInput);
            if (err && err.name === "AbortError") return;
            window.location.reload();
        } finally {
            cleanupController(key, controller);
            endUpdate(ctx);
        }
    }
    async function changeBundle(bundleId, keys, quantity, primaryKey) {
        invalidateCartSnapshot();
        const ctx = getCartContext();
        if (!ctx || !bundleId || !keys || !keys.length) return;
        const activeEl = document.activeElement;
        rememberFocus(activeEl && ctx.root.contains(activeEl) ? activeEl : null);
        const row = primaryKey ? ctx.root.querySelector(`tr.cart_item[data-line-key="${cssEscape(primaryKey)}"]`) : ctx.root.querySelector(`tr.cart_item[data-bundle-id="${cssEscape(bundleId)}"][data-bundle-master="1"]`);
        const itemLabel = row ? row.getAttribute("data-item-label") || "Item" : "Item";
        const stateKey = `bundle:${bundleId}`;
        clearTimer(stateKey);
        const prev = state.controllers.get(stateKey);
        if (prev) {
            try {
                prev.abort();
            } catch (e) {}
        }
        const controller = new AbortController;
        state.controllers.set(stateKey, controller);
        beginUpdate(ctx);
        if (Math.max(0, parseInt(quantity, 10) || 0) === 0 && willCartBeEmptyAfterRemove(ctx, row, bundleId)) {
            clearHeaderCartImmediately();
        }
        try {
            const cart = await postBundleUpdate(keys, quantity, controller.signal);
            const ok = applyCartState(ctx, cart);
            if (ok) refreshQtyButtonStates(ctx.root);
            syncCartEcho(cart);
            emitCartUpdated(cart, "es-cart-page");
            const statusMessage = quantity === 0 ? `${itemLabel} removed.` : `${itemLabel} quantity updated to ${Math.max(0, quantity)}.`;
            setStatus(ctx, statusMessage);
            releaseLoadingUI(ctx);
            if (!ok) {
                const markupOk = await refreshCartMarkupFromServer("es-cart-page", statusMessage);
                if (!markupOk) window.location.reload();
            }
        } catch (err) {
            const qtyInput = row ? row.querySelector(".js-qty__num, .cart-qty-input") : null;
            clearPendingQty(qtyInput);
            if (err && err.name === "AbortError") return;
            window.location.reload();
        } finally {
            cleanupController(stateKey, controller);
            endUpdate(ctx);
        }
    }
    function scheduleChange(line, quantity, itemKey) {
        if (!line) return;
        const key = itemKey || String(line);
        clearTimer(key);
        state.timers.set(key, window.setTimeout(() => {
            clearTimer(key);
            changeLine(line, quantity, key);
        }, DEBOUNCE_MS));
    }
    function scheduleBundleChange(bundleId, keys, quantity, primaryKey) {
        if (!bundleId || !keys || !keys.length) return;
        const stateKey = `bundle:${bundleId}`;
        clearTimer(stateKey);
        state.timers.set(stateKey, window.setTimeout(() => {
            clearTimer(stateKey);
            changeBundle(bundleId, keys, quantity, primaryKey);
        }, DEBOUNCE_MS));
    }
    function shouldSkipQtyRequest(info, nextQty) {
        if (!info || !info.tr) return false;
        const qtyInput = info.tr.querySelector(".js-qty__num, .cart-qty-input");
        if (!qtyInput) return false;
        const targetQty = Math.max(0, parseInt(nextQty, 10) || 0);
        const committedQty = getCommittedQty(qtyInput);
        const pendingQty = getPendingQty(qtyInput);
        if (pendingQty !== null && pendingQty === targetQty) return true;
        if (pendingQty === null && committedQty !== null && committedQty === targetQty) return true;
        setPendingQty(qtyInput, targetQty);
        return false;
    }
    function getRowInfoFromEl(el) {
        const tr = el && el.closest ? el.closest("tr.cart_item") : null;
        if (!tr) return null;
        const line = parseInt(tr.getAttribute("data-cart-line") || "", 10);
        const key = tr.getAttribute("data-line-key") || "";
        const bundleId = tr.getAttribute("data-bundle-id") || "";
        return {
            tr: tr,
            line: Number.isFinite(line) ? line : 0,
            key: key,
            bundleId: bundleId
        };
    }
    function getBundleKeys(bundleId, root) {
        if (!bundleId || !root) return [];
        const rows = Array.from(root.querySelectorAll(`tr.cart_item[data-bundle-id="${cssEscape(bundleId)}"]`));
        const keys = rows.map(row => row.getAttribute("data-line-key") || "").filter(Boolean);
        return Array.from(new Set(keys));
    }
    document.addEventListener("input", e => {
        const input = e.target && e.target.closest ? e.target.closest(".cart-qty-input, .js-qty__num") : null;
        if (!input) return;
        if (!input.closest(".page-cart")) return;
        const nextQty = maybeClampInputToLimit(input, input.value, true);
        updateQtyButtonState(input);
        const info = getRowInfoFromEl(input);
        if (!info || !info.line) return;
        if (shouldSkipQtyRequest(info, nextQty)) return;
        const bundleKeys = info.bundleId ? getBundleKeys(info.bundleId, document) : [];
        if (bundleKeys.length > 1) {
            scheduleBundleChange(info.bundleId, bundleKeys, nextQty, info.key);
        } else {
            scheduleChange(info.line, nextQty, info.key);
        }
    }, {
        passive: true
    });
    document.addEventListener("change", e => {
        const input = e.target && e.target.closest ? e.target.closest(".cart-qty-input, .js-qty__num") : null;
        if (!input) return;
        if (!input.closest(".page-cart")) return;
        const nextQty = maybeClampInputToLimit(input, input.value, true);
        updateQtyButtonState(input);
        const info = getRowInfoFromEl(input);
        if (!info || !info.line) return;
        if (shouldSkipQtyRequest(info, nextQty)) return;
        const bundleKeys = info.bundleId ? getBundleKeys(info.bundleId, document) : [];
        if (bundleKeys.length > 1) {
            scheduleBundleChange(info.bundleId, bundleKeys, nextQty, info.key);
        } else {
            scheduleChange(info.line, nextQty, info.key);
        }
    }, {
        passive: true
    });
    document.addEventListener("keydown", e => {
        const input = e.target && e.target.closest ? e.target.closest(".cart-qty-input, .js-qty__num") : null;
        if (!input) return;
        if (!input.closest(".page-cart")) return;
        if (e.key === "Enter") {
            rememberFocus(input);
            e.preventDefault();
            const info = getRowInfoFromEl(input);
            if (!info || !info.line) return;
            const nextQty = maybeClampInputToLimit(input, input.value, true);
            if (shouldSkipQtyRequest(info, nextQty)) return;
            const bundleKeys = info.bundleId ? getBundleKeys(info.bundleId, document) : [];
            if (bundleKeys.length > 1) {
                changeBundle(info.bundleId, bundleKeys, nextQty, info.key);
            } else {
                changeLine(info.line, nextQty, info.key);
            }
        }
    });
    document.addEventListener("click", e => {
        const btn = e.target && e.target.closest ? e.target.closest(".page-cart .es-qty-btn--plus") : null;
        if (!btn) return;
        const wrap = btn.closest(".es-qty-control");
        const input = wrap ? wrap.querySelector(".js-qty__num, .cart-qty-input") : null;
        if (!input) return;
        const max = getMaxQty(input);
        const qty = parseQty(input.value);
        if (max === null || qty < max) return;
        rememberFocus(btn);
        e.preventDefault();
        e.stopPropagation();
        const ctx = getCartContext();
        if (ctx) setStatus(ctx, getQtyLimitMessage(input));
        setQtyLimitNote(input, true);
    }, true);
    document.addEventListener("click", e => {
        const btn = e.target && e.target.closest ? e.target.closest(".page-cart .js-qty__adjust") : null;
        if (!btn) return;
        rememberFocus(btn);
        const info = getRowInfoFromEl(btn);
        if (!info || !info.line) return;
        window.setTimeout(() => {
            const qtyInput = info.tr.querySelector(".js-qty__num, .cart-qty-input");
            if (!qtyInput) return;
            const nextQty = maybeClampInputToLimit(qtyInput, qtyInput.value, true);
            if (shouldSkipQtyRequest(info, nextQty)) return;
            const bundleKeys = info.bundleId ? getBundleKeys(info.bundleId, document) : [];
            if (bundleKeys.length > 1) {
                scheduleBundleChange(info.bundleId, bundleKeys, nextQty, info.key);
            } else {
                scheduleChange(info.line, nextQty, info.key);
            }
        }, 0);
    });
    document.addEventListener("click", e => {
        const link = e.target && e.target.closest ? e.target.closest(".page-cart a.remove") : null;
        if (!link) return;
        if (link.getAttribute("aria-disabled") === "true") return;
        const info = getRowInfoFromEl(link);
        let line = info && info.line ? info.line : 0;
        if (!line) {
            const href = link.getAttribute("href") || "";
            const m = href.match(/line=(\d+)/);
            if (m) line = parseInt(m[1], 10);
        }
        if (!line) return;
        rememberFocus(link);
        e.preventDefault();
        if (info && info.tr) {
            info.tr.style.opacity = "0.6";
            info.tr.style.pointerEvents = "none";
        }
        const bundleKeys = info && info.bundleId ? getBundleKeys(info.bundleId, document) : [];
        if (bundleKeys.length > 1) {
            changeBundle(info.bundleId, bundleKeys, 0, info && info.key ? info.key : String(line));
        } else {
            changeLine(line, 0, info && info.key ? info.key : String(line));
        }
    });
    function bindAjaxCartSync() {
        return false;
    }
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
            const ctx = getCartContext();
            if (ctx && state.updating === 0) releaseLoadingUI(ctx);
        }
    });
    window.addEventListener("pageshow", () => {
        const ctx = getCartContext();
        if (ctx && state.updating === 0) releaseLoadingUI(ctx);
        refreshQtyButtonStates(document);
    });
    window.addEventListener("pagehide", () => {
        cleanupTransientState();
    });
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => refreshQtyButtonStates(document), {
            once: true
        });
    } else {
        refreshQtyButtonStates(document);
    }
    document.addEventListener("cart:updated", event => {
        const detail = event && event.detail ? event.detail : {};
        const detailCart = detail && detail.cart ? detail.cart : null;
        if (detailCart && typeof detailCart.item_count !== "undefined") {
            updateHeaderCartCount(detailCart.item_count);
        } else if (detail.source !== "es-cart-page") {
            queueHeaderBadgeSyncFromServer(70, true);
        }
        if (!detailCart || detail.source === "es-cart-page") return;
        const ctx = getCartContext();
        if (!ctx) return;
        const ok = applyExternalCartUpdate(detailCart, detail.source, "Cart updated.");
        if (!ok) {
            refreshCartPageFromServer(detail.source).then(synced => {
                if (!synced) window.location.reload();
            });
            return;
        }
        queueRefreshFromServer(detail.source, true, 48);
    });
    window.EyeshellsCartPageSync = {
        applyCart(cart, source = "external") {
            const ok = applyExternalCartUpdate(cart, source, "Cart updated.");
            if (!ok) {
                refreshCartPageFromServer(source).then(synced => {
                    if (!synced) window.location.reload();
                });
            }
            return ok;
        },
        refreshFromServer(source = "external") {
            return refreshCartPageFromServer(source, true);
        }
    };
    const LEGACY_CART_PROPERTY_KEYS = [
        "_bundleId",
        "_productType",
        "_bundleOrder",
        "Bundle Role",
        "Bundle Order",
        "_parent",
        "_Frame",
        "_Lens Builder Id",
        "_Lens Exact Title",
        "_Lens Expected Price",
        "_Lens Product Handle",
        "_Lens Variant Id",
        "_Prescription Method",
        "_Prescription Status",
        "_Prescription File Name"
    ];
    function isLegacyLabMachineNote(value) {
        const text = String(value || "").replace(/\s+/g, " ").trim();
        return /^H\s+Decenter\b/i.test(text);
    }
    function buildBundleMetaFromLegacyProps(props) {
        props = props || {};
        if (String(props._eslb || "").trim()) return "";
        const id = String(props._bundleId || "").trim();
        if (!id) return "";
        const role = String(props._productType || props["Bundle Role"] || "").trim().toLowerCase();
        const order = String(props._bundleOrder || props["Bundle Order"] || "").trim();
        if (!role && !order) return "";
        return [id, role, order].join("|");
    }
    function sanitizeCartProperties(props) {
        props = props || {};
        let changed = false;
        const next = {};
        const migratedMeta = buildBundleMetaFromLegacyProps(props);
        Object.keys(props).forEach(key => {
            if (LEGACY_CART_PROPERTY_KEYS.indexOf(key) > -1) {
                changed = true;
                return;
            }
            const value = props[key];
            if ((key === "_Notes" || key === "Notes") && isLegacyLabMachineNote(value)) {
                changed = true;
                return;
            }
            if (key === "_Notes") {
                if (value != null && String(value).trim()) {
                    next["Customer Notes"] = value;
                }
                changed = true;
                return;
            }
            next[key] = value;
        });
        if (migratedMeta && !next._eslb) {
            next._eslb = migratedMeta;
            changed = true;
        }
        return changed ? next : null;
    }
    async function scrubLegacyCartProperties() {
        try {
            const cart = await fetchCart(true);
            if (!cart || !Array.isArray(cart.items) || !cart.items.length) return false;
            let changed = false;
            for (const item of cart.items) {
                const cleaned = sanitizeCartProperties(item && item.properties || {});
                if (!cleaned) continue;
                changed = true;
                await fetch(cartUrl("cart/change.js"), {
                    method: "POST",
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify({
                        id: item.key,
                        quantity: item.quantity,
                        properties: cleaned
                    })
                });
            }
            if (changed) invalidateCartSnapshot();
            return changed;
        } catch (e) {
            return false;
        }
    }
    function bindLegacyCartPropertyScrub() {
        const ctx = getCartContext();
        if (ctx) {
            scrubLegacyCartProperties().then(changed => {
                if (changed) refreshCartMarkupFromServer("legacy-property-scrub", "Cart updated.");
            });
        }
        document.addEventListener("click", function(e) {
            const target = e && e.target && e.target.closest ? e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], .checkout-button') : null;
            if (!target || target.__esLegacyScrubbed) return;
            e.preventDefault();
            e.stopPropagation();
            scrubLegacyCartProperties().finally(() => {
                target.__esLegacyScrubbed = true;
                if (target.tagName === "A" && target.href) {
                    window.location.href = target.href;
                    return;
                }
                const form = target.closest && target.closest("form");
                if (form && typeof form.submit === "function") form.submit();
                else target.click();
            });
        }, true);
    }
    bindLegacyCartPropertyScrub();
    const initialCtx = getCartContext();
    if (initialCtx) {
        suppressLeakedDrawerLoading();
        const initialCountNode = initialCtx.root.querySelector("[data-es-cart-display-count-text]");
        if (initialCountNode) {
            const match = (initialCountNode.textContent || "").match(/\d+/);
            if (match) updateHeaderCartCount(parseInt(match[0], 10));
        }
    }
    if (!bindAjaxCartSync()) {
        let tries = 0;
        const t = window.setInterval(() => {
            tries += 1;
            if (bindAjaxCartSync() || tries >= 20) window.clearInterval(t);
        }, 100);
    }
    /* ES 766: Header cart dot is handled by es-cart-header-badge.js and cart:updated events.
       Do not patch global fetch/XHR here; doing so caused extra /cart.js checks during repeated add/remove tests. */
})();
